import { render } from "./EventDialog.vue?vue&type=template&id=9b28fe18&scoped=true"
import script from "./EventDialog.vue?vue&type=script&lang=js"
export * from "./EventDialog.vue?vue&type=script&lang=js"

import "./EventDialog.vue?vue&type=style&index=0&id=9b28fe18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b28fe18"]])

export default __exports__